import React from 'react';
import { Box, Typography } from '@mui/material';
import CapabilityCard from './shared/CapabilityCard';
import GridContainer from './shared/GridContainer';
import StatsContainer from './shared/StatsContainer';
import StatCard from './shared/StatCard';
import ActionButton from './shared/ActionButton';
import FeatureList from './shared/FeatureList';

interface ReportsContentProps {
  onContentChange?: (contentId: string) => void;
  onActionClick?: (action: string, data?: any) => void;
}

const ReportsContent: React.FC<ReportsContentProps> = ({ onContentChange, onActionClick }) => {
  return (
    <Box>
      <Typography variant="h4" sx={{ fontFamily: 'var(--font-heading)', color: 'var(--primary-blue)', mb: 2 }}>
        📊 Comprehensive Reporting
      </Typography>
      <Typography sx={{ fontFamily: 'var(--font-body)', color: 'var(--dark-gray)', mb: 3 }}>
        Generate detailed reports for candidates, interviews, and recruitment analytics.
      </Typography>

      <StatsContainer>
        <StatCard number="15+" label="Report Types" />
        <StatCard number="PDF/Excel" label="Export Formats" />
        <StatCard number="Real-time" label="Data Updates" />
      </StatsContainer>

      <GridContainer>
        <CapabilityCard icon="👤" title="Candidate Reports">
          <FeatureList
            items={[
              'Detailed candidate assessment',
              'Skills gap analysis',
              'Interview performance summary',
              'Recommendation scores',
            ]}
          />
        </CapabilityCard>

        <CapabilityCard icon="📈" title="Analytics Dashboard">
          <FeatureList
            items={[
              'Recruitment pipeline metrics',
              'Time-to-hire analytics',
              'Source effectiveness',
              'Diversity and inclusion stats',
            ]}
          />
        </CapabilityCard>
      </GridContainer>

      <Box sx={{ mt: 3 }}>
        <ActionButton onClick={() => onActionClick?.('generate-report')}>
          Generate Report
        </ActionButton>
        <ActionButton onClick={() => onActionClick?.('view-templates')}>
          View Templates
        </ActionButton>
        <ActionButton onClick={() => onActionClick?.('schedule-reports')}>
          Schedule Reports
        </ActionButton>
      </Box>
    </Box>
  );
};

export default ReportsContent;

